import React from "react";

import { motion } from "framer-motion";

const Header = ({ title, tagline, subtitle, image, id }) => {
    return (
        <>
            <motion.header 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.6, ease: [0.43, 0.13, 0.23, 0.96] }}
                style={{ backgroundImage: `linear-gradient(45deg, #00000047, #00000085), url(${image})` }}
                className={id ? "page-header-" + id : "page-header"}>
                <div className="container">
                    <p>{ subtitle }</p>
                    <h1>{ title }</h1>
                    <h2>{ tagline }</h2>
                </div>
            </motion.header>
        </>
    );
};

export default Header;